import AppError from './AppError'

export class AuthenticationError extends AppError {
  name = 'Authentication error'
  constructor() {
    super()
    this.message = `Authentication with Auth0 failed`
  }
}
